import icEdit from "assets/images/ic-edit-04.svg";
import { setCurrency } from "utils/utils";
import icEyeOpen from "../../assets/images/ic-eye-open.svg";
import icTrash01Red from "../../assets/images/ic-trash-01-red.svg";
import Badge from "../../components/commons/badge";
import Button from "../../components/commons/button";
import { ACTION_TYPE } from "../../constants/constant";

export const INITIAL_DATA_QUERY = {
    page: 1,
    limit: 20,
    search: ''
}

export const TABLE_EMPLOYEE_PRODUCTIVITY_LIST = {
    name: 'Data Period Productivity',
    column: [
        {
            name: "Period",
            key: "period",
            className: "font-bold capitalize"
        },
        {
            name: "Headcount",
            key: "headcount",
            classNameHeader: '!text-center',
            className: 'text-center',
            sortable: true
        },
        {
            name: "Salary Cost",
            key: "salary_cost",
            sortable: true,
            render: ({value}) => value ? setCurrency(value) : '-'
        },
        {
            name: "KPI",
            key: "kpi_percentage",
            classNameHeader: '!text-center',
            className: 'w-20 text-center',
            sortable: true
        },
        {
            name: "Cost / Headcount",
            key: "cost_per_headcount",
            sortable: true,
            render: ({value}) => value ? setCurrency(value) : '-'
        },
        {
            name: "Cost per 1% KPI",
            key: "cost_per_kpi",
            sortable: true,
            render: ({value}) => value ? setCurrency(value) : '-'
        },
        {
            name: "Status",
            key: "status",
            render: ({value}) => value ? <Badge title={value} type={value?.toLowerCase()}/> : ''
        },
        {
            name: "Action",
            key: "action",
            classNameHeader: "!text-center",
            render: ({item, onClickItem}) => (
                <div className="flex space-x-4 justify-center">
                    <Button
                        className="w-[80px]" 
                        type="outline"
                        icon={icEyeOpen}
                        title="Detail"
                        onClick={() => onClickItem({item, actionType: ACTION_TYPE.DETAIL})}
                    />
                    <Button
                        type="danger"
                        icon={icTrash01Red}
                        onClick={() => onClickItem({item, actionType: ACTION_TYPE.DELETE})}
                    />
                </div>
            )
        }
    ]
}

export const INITIAL_DATA_QUERY_EMPLOYEE_PRODUCTIVITY_DETAIL = {
    page: 1,
    limit: 20,
    search: ''
}

export const DEFAULT_FORM_EMPLOYEE_PRODUCTIVITY = {
    job_title_id: null,
    kpi_value: null,
    salary_value: null,
}

export const TABLE_EMPLOYEE_PRODUCTIVITY_DETAIL = {
    name: 'Data Employee Productivity',
    column: [
        {
            name: "Nama Karyawan",
            key: "employee_name",
            className: "font-bold capitalize"
        },
        {
            name: "NIP",
            key: "employee_nip",
        },
        {
            name: "Job Title Karyawan",
            key: "job_title",
            render: ({value}) => value?.name || '-'
        },
        {
            name: "Department",
            key: "department",
            render: ({value}) => value?.name || '-'
        },
        {
            name: "Divisi",
            key: "division",
            render: ({value}) => value?.name || '-'
        },
        {
            name: "KPI",
            key: "kpi_value",
            className: "w-20 font-bold",
            sortable: true
        },
        {
            name: "Salary",
            key: "salary_value",
            className: "min-w-32 font-bold",
            sortable: true,
            render: ({value}) => value ? setCurrency(value) : '-'
        },
        {
            name: "Cost per 1% KPI",
            key: "cost_per_kpi",
            className: "min-w-40 font-bold",
            sortable: true,
            render: ({value}) => value ? setCurrency(value) : '-'
        },
    ]
}

export const TABLE_EMPLOYEE_PRODUCTIVITY_IMPORT_DATA = {
    name: 'Data Employee Productivity',
    column: [
        {
            name: "Nama Karyawan",
            key: "employee_name",
            className: "font-bold capitalize"
        },
        {
            name: "NIP",
            key: "employee_nip",
        },
        {
            name: "Job Title Karyawan",
            key: "job_title",
            render: ({value}) => value?.name || '-'
        },
        {
            name: "Department",
            key: "department",
            render: ({value}) => value?.name || '-'
        },
        {
            name: "Divisi",
            key: "division",
            render: ({value}) => value?.name || '-'
        },
        {
            name: "KPI",
            key: "kpi_value",
            className: "w-20 font-bold",
        },
        {
            name: "Salary",
            key: "salary_value",
            className: "min-w-32 font-bold",
            render: ({value}) => value ? setCurrency(value) : '-'
        },
        {
            name: "Action",
            key: "action",
            classNameHeader: "!text-center",
            render: ({item, onClickItem}) => (
                <div className="flex space-x-4 justify-center">
                    <Button 
                        icon={icEdit} 
                        type="outline"
                        onClick={() => onClickItem({item, actionType: ACTION_TYPE.EDIT})}
                    />
                    <Button
                        type="danger"
                        icon={icTrash01Red}
                        onClick={() => onClickItem({item, actionType: ACTION_TYPE.DELETE})}
                    />
                </div>
            )
        }

    ]
}

export const TABLE_EMPLOYEE_PRODUCTIVITY_IMPORT = [ 
    {
        name: "Nama Karyawan",
        key: "employee_name",
        className: "font-bold capitalize"
    },
    {
        name: "NIP",
        key: "employee_nip",
    },
    {
        name: "KPI",
        key: "kpi_value",
        className: "font-bold"
    },
    {
        name: "Salary",
        key: "salary_value",
        className: "font-bold"
    },
    {
        name: 'Status',
        key: 'status',
        width: 250,
        render: () => <Badge title='invalid' type='invalid'/>
    },
]
